import ZINDEX_LAYERS from "../../constants/zIndexLayers";
import usePalette from "../../hooks/usePalette";
import Box from "../components-dev/BoxExtended";
import { getSizing } from "../sizing";
import { Checkbox, IconButton } from "@mui/material";

interface IXNGCheckbox {
  checked: boolean;
  onToggle: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  disabled?: boolean;
  ariaLabel?:string
}

/**
 * ## DEPRECATED
 *
 * Do not reuse or modify, replace references with MUI / Fortitude components in new development.
 *
 * See: https://msb-tlm.atlassian.net/wiki/spaces/XL/pages/508035073/MSB+Design+System+Fortitude#Note-for-Developers%3A-Deprecated-Design-System-Exists-in-XNG-Codebase
 */
function XNGCheckbox(props: IXNGCheckbox) {
  const palette = usePalette();
  const { disabled } = props;

  return (
    <Box
      sx={{
        position: "relative",
        svg: { color: palette.contrasts[3] },
        ".Mui-checked": {
          svg: {
            color: disabled ? "inherit" : palette.primary[2],
          },
        },
        ".Mui-checked:hover": {
          bgcolor: "unset",
        },
        button: {
          padding: 0,
        },
      }}
    >
      {/* <IconButton> */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: ZINDEX_LAYERS.xngCheckboxRipple,
        }}
      >
        <Checkbox
          size="small"
          sx={{
            ".MuiTouchRipple-root": { display: "none" },
            zIndex: ZINDEX_LAYERS.xngCheckbox,
            svg: { color: "#c1c1c1" },
          }}
          checked={props.checked}
          onClick={(e) => props.onToggle(e)}
          disabled={disabled}
          {...(props?.ariaLabel ? { inputProps: { "aria-label": props.ariaLabel } } : {})}
        />
      </Box>
      {/* </IconButton> */}
    </Box>
  );
}

export default XNGCheckbox;
